import { QueryKey } from "@tanstack/react-query";

export const kisiQueryKeys = {
  all: () => ["kisi"] as QueryKey,
  groupMappings: () => [...kisiQueryKeys.all(), "group-mappings"] as QueryKey,
  places: () => [...kisiQueryKeys.all(), "places"] as QueryKey,
  groups: () => [...kisiQueryKeys.all(), "groups"] as QueryKey,
  brandConfig: () => [...kisiQueryKeys.all(), "brandConfig"],
};
